import { createActionGroup, emptyProps } from '@ngrx/store';
import { UpdateUserRequest, ProductType, UserResponse } from '@core/contracts/data-contracts';
import { PortingOption } from '@core/enums';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Get User Details': emptyProps(),
    'Get User Details Success': (user: UserResponse) => ({ user }),
    'Get User Details Failure': emptyProps(),
    'Change Current Msisdn': (customerId: number) => ({ customerId }),
    'Clear User Details': emptyProps(),

    'Change Email': (email: string) => ({ email }),
    'Change Email Success': (email: string) => ({ email }),
    'Change Email Failure': emptyProps(),
    'Clear Email Request Status': emptyProps(),

    'Change Password': (oldPassword: string, newPassword: string) => ({
      oldPassword,
      newPassword,
    }),
    'Change Password Success': emptyProps(),
    'Change Password Failure': emptyProps(),
    'Clear Password Request Status': emptyProps(),

    'Update User': (payload: UpdateUserRequest) => ({ payload }),
    'Update User Success': (payload: UpdateUserRequest) => ({
      payload,
    }),
    'Update User Failure': emptyProps(),
    'Clear Update User Request Status': emptyProps(),

    'Sign Out': emptyProps(),

    'Resolve Porting Block': (payload: PortingOption) => ({ payload }),
    'Resolve Porting Block Success': emptyProps(),
    'Resolve Porting Block Failure': emptyProps(),

    'Set Active Product': (product: ProductType) => ({ product }),
  },
});
